module.exports = __webpack_public_path__ + "img/app4.313678f6.png";